// GENERATED FILE - DO NOT MODIFY
export enum SynchronizationStatus {
    Synchronized = 0,
    ManuallySynchronized = 1,
    New = 2,
    Update = 3,
}

export let nameof = "SynchronizationStatus";
